import { GymForm } from "./GymForm";
import { Gym } from "./types";

interface GymListProps {
  gyms: Gym[];
  selectedGym: Gym | null;
  isEditing: boolean;
  gymName: string;
  gymAddress: string;
  onSave: (gymId: string, name: string, address: string, logoFile: File | null) => void;
  onCancel: () => void;
  onEdit: (gym: Gym) => void;
  onDelete: (gymId: string) => void;
}

export const GymList = ({
  gyms,
  selectedGym,
  isEditing,
  gymName,
  gymAddress,
  onSave,
  onCancel,
  onEdit,
  onDelete,
}: GymListProps) => {
  return (
    <div className="space-y-4">
      {gyms.map((gym) => (
        <div
          key={gym.id}
          className="p-5 rounded-xl bg-gradient-to-br from-card/80 to-card/40 border border-border/50 shadow-sm hover:shadow-md hover:border-border/70 transition-all duration-200"
        >
          <GymForm
            gymId={gym.id}
            gymName={selectedGym?.id === gym.id ? gymName : gym.name}
            gymAddress={selectedGym?.id === gym.id ? gymAddress : gym.address}
            gymCode={gym.code}
            gymLogoUrl={gym.logo_url}
            isEditing={isEditing && selectedGym?.id === gym.id}
            onSave={(name, address, logoFile) => onSave(gym.id, name, address, logoFile)}
            onCancel={onCancel}
            onEdit={() => onEdit(gym)}
            onDelete={() => onDelete(gym.id)}
          />
        </div>
      ))}
    </div>
  );
};